<div [id]="nombreMap" class="map-container">
  <div class="flotante">
    <div class="row-flex-start" style="gap: 8px; margin-left: 0.3em"></div>
  </div>
</div>
